import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Get the token from sessionStorage
  const token = sessionStorage.getItem('token');

  // If the token doesn't exist or is invalid, redirect to login
  if (!token) {
    return <Navigate to="/login" />;
  }

  return children; // If token exists, render the child components (protected route)
};

export default ProtectedRoute;
